<template>
<div id="dingdanzl">
   <!-- 头部组件 -->
   <component :is="header_"></component>
   <!--  -->
   <el-container v-loading="loading" element-loading-text="拼命加载中" style="height: 100vh; border: 1px solid #eee">
   <!-- 侧栏组件 -->
   <component :is="celan"></component>
    
   <el-row>  
      <div class="containers" style="width: 100%;">
        <div class="row">
          <div class="col-sm">
            <div class="row">
               <div class="" style="width: 50%;">
                  <div class="cjje1">
                    <p class="cjje_"><i class="iconfontqianqian-"></i></p>
                    <p class="cjje_">成交总金额</p>
                  </div>
               </div>
               <div class="" style="width: 50%;">
                  <div class="cjje2">{{paymoney}}元</div>
               </div>
            </div>
          </div>    

          <div class="col-sm">
            <div class="row">
               <div class="" style="width: 50%;">
                 <div class="cjje1" style="background: #9CD159">
                    <p class="cjje_"><i class="iconfontgouwuche"></i></p>
                    <p class="cjje_">总订单</p>
                 </div>
               </div>
               <div class="" style="width: 50%;">
                 <div class="cjje2" style="background: #72b63f">
                    {{payzongdd}}笔
                 </div>
               </div>
            </div>
          </div>    

          <div class="col-sm">
            <div class="row">
               <div class="" style="width: 50%;">
                 <div class="cjje1" style="background: #ad96d6">
                    <p class="cjje_"><i class="iconfontqianqian-"></i></p>
                    <p class="cjje_">今日成交金额</p>
                 </div>
               </div>
               <div class="" style="width: 50%;">
                 <div class="cjje2" style="background: #8775a7">
                    {{jinrimoney}}元
                 </div>
               </div>
            </div>
          </div>    

          <div class="col-sm">
            <div class="row">
               <div class="" style="width: 50%;">
                 <div class="cjje1" style="background: #FF7171">
                    <p class="cjje_"><i class="iconfontgouwuche"></i></p>
                    <p class="cjje_">今日总订单</p>
                 </div>
               </div>
               <div class="" style="width: 50%;">
                 <div class="cjje2" style="background: #ff5757">
                    {{jinridd}}笔
                 </div>
               </div>
            </div>
          </div>

        </div>
      </div>


      <el-col :span="6" class="el-col-max" style="height: 100vh;padding-right:16px;">
        <!-- 时间 -->
        <div class="main" style="background: #efefef;padding-top:0;">

            <div style="height:239px;background: #efefef;">
                <el-col :span="24" style="padding-left: 0px;padding-right: 0px;text-align: center;">
                   <div style="margin-top: 29px;">
                       <img style="width:120px;border-radius:50%;" src="./../../static/user.png">
                   </div>
                   <div @click="exit_login" style="font-size: 20px;padding-top:8%;padding-bottom:10%;cursor:default">
                       欢迎 {{name}}
                   </div>
                </el-col>
            </div>
            <div class="grid-content bg-purple" style="">
                <el-col :span="24" style="padding-left: 0px;padding-right: 0px;">
                   <div class="cjje1" style="background:#efefef;color:#60a7d0;border-top: 1px dashed #fff;">
                      <p class="cjje_">{{xq}}</p>
                      <p class="cjje_">
                          {{tiao_nyr}}
                      </p>
                   </div>

                   <div class="cjje2" style="background:#efefef;color:#8775a7;font-size:50px;font-weight:bold;border-top: 1px dashed #fff;border-bottom: 1px dashed #fff;">
                          {{tiao_time}}
                   </div>

                </el-col>

            </div>

        </div>
      </el-col>
      <el-col :span="18" class="main-vh">
        <!-- echarts饼图 -->
        <div class="main">
            <div id="main"></div>
        </div>
      </el-col>
   </el-row>


</el-row>

    </el-container>
</div>
</template>

<script>
//头部组件
import header_ from './header_.vue'
import celan from './celan.vue'

export default {
  name: 'dingdanzl',
   data() {
      return {
        header_:header_,
        celan:celan,
        paymoney:'',
        payzongdd:'',
        jinrimoney:'',
        jinridd:'',
        jinri_sucessdd_dd:'',
        name:null,
        xq:null,
        tiao_nyr:null,
        tiao_time:null,
        loading: true,
        geturl:'./login.php',
      }
    },
    methods: {
        // 饼图
        echarts(){
          var dom = document.getElementById("main");
          var myChart = this.Vecharts.init(dom);
          var app = {};
          var option = null;
          option = {
              title : {
                  text: '数据总览图',
                  subtext: '',
                  x:'center'
              },
              tooltip : {
                  trigger: 'item',
                  formatter: "{a} <br/>{b} : {c} ({d}%)"
              },
              legend: {
                  orient: 'vertical',
                  left: 'left',
                  data: ['成交总金额','总订单','今日成交金额','今日总订单','今日成交订单']
              },
              series : [
                  {
                      name: '数据',
                      type: 'pie',
                      radius : '65%',
                      center: ['50%', '60%'],
                      data:[
                          {
                            value:this.paymoney, 
                            name:'成交总金额',
                            itemStyle:{
                              normal:{color:'#60a7d0'}
                            }
                          },
                          {
                            value:this.payzongdd,
                            name:'总订单',
                            itemStyle:{
                              normal:{color:'#9cd159'}
                            }
                          },
                          {
                            value:this.jinrimoney, 
                            name:'今日成交金额',
                            itemStyle:{
                              normal:{color:'#ad96d6'}
                            }
                          },
                          {
                            value:this.jinridd, 
                            name:'今日总订单',
                            itemStyle:{
                              normal:{color:'#ff7171'}
                            }
                          },
                          {
                            value:this.$jinri_sucessdd_dd, 
                            name:'今日成交订单',
                            itemStyle:{
                              normal:{color:'#b3c0d1'}
                            }
                          }
                      ],
                      itemStyle: {
                          emphasis: {
                              shadowBlur: 10,
                              shadowOffsetX: 0,
                              shadowColor: 'rgba(0, 0, 0, 0.5)'
                          }
                      }
                  }
              ]
          };
          if (option && typeof option === "object") {
              myChart.setOption(option, true);
          }
        },
        //点击用户名退出用户
        exit_login(){
           //调用header_.vue里的方法
           this.$parent.$refs.exit_logins.exit_login();
        }
    },
    created(){
    },
    mounted() {
      //请求数据
      this.$http.post(this.geturl,{true_:true},{emulateJSON:true}).then(res=>{
        //关闭加载
        this.loading=false;
        var moy=res.body;
        this.paymoney=moy[0];
        this.payzongdd=moy[1];
        this.jinrimoney=moy[2];
        this.jinridd=moy[3];
        this.$jinri_sucessdd_dd=moy[4];
        //调用
        this.echarts();
      });
      //获取星期几
      var a = ["日", "一", "二", "三", "四", "五", "六"];  
      var week = new Date().getDay();  
      this.xq = "星期"+ a[week]; 
      // 获取年月日
      var now = new Date();
      var year = now.getFullYear();       //年
      var month = now.getMonth() + 1;     //月
      var day = now.getDate();            //日
      this.tiao_nyr = year+"-"+month+"-"+day;
      // 获取时分秒
      // setInterval(()=>{
        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分
        var ss = now.getSeconds();          //秒
        hh<10?hh='0'+hh:hh; 
        mm<10?mm='0'+mm:mm; 
        ss<10?ss='0'+ss:ss;
        this.tiao_time = hh+":"+mm+":"+ss;
      // },1000);
      //获取用户名
      this.name = sessionStorage.getItem("uname");

    }
}
</script>


<style scoped>
.el-row {
    width: 100%;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  height: 100px;
}
.row-bg {
  background-color: #f9fafc;
}
.cjje1,.cjje2{
   width: 100%;
   background: #60A7D0;
   height: 100px;
   color: #fff;
   font-size: 24px;
   line-height: 67px;
   text-align: center;
   white-space:normal;
   overflow: hidden;
}  
.cjje2{
   background: #438eb9;
   line-height: 100px;
}
.cjje_{
  height: 38px;
  margin-bottom: 0rem;
}

/*图表*/

.main-vh{
  height: 100vh;
}
.main{
    width: 98%;
    height: 100%;
    margin-left: 10px;
    margin-right: 10px;
    margin-top: 23px;
    padding-top: 2%;
    background: #f7f7f7;
}
#main {
    width: 100%;
    height: 65%;
}


/*********************/

>>> .containers .row {
     margin-right: 0px; 
     margin-left: 0px; 
}
>>> .containers .col-sm {
    padding-left: 11px;
    padding-right: 13px;
}
@media screen and (max-width: 800px) {
  >>> .containers .col-sm {
     padding-right: 0px; 
     padding-left: 0px; 
  }
  .el-col-18 {
    width: 100%;
  }
  .main-vh{
    height: 50rem;
  }
  .main {
    width: 100%;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    padding-top: 5%;
    background: #f7f7f7;
  }
  .el-col-max {
    display: none;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/dingdanzl.vue